var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnectButtonSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50613 -2.25788e-06C7.18323 -2.28611e-06 6.91994 0.28042 6.91994 0.624338C6.91994 0.968252 7.18323 1.24867 7.50613 1.24867L32.1609 1.24868L32.1609 19.9471C32.1609 19.9683 32.1559 19.9894 32.1559 20.0106C32.1559 20.0317 32.1559 20.0529 32.1609 20.0741L32.1609 38.7513L7.50612 38.7513C7.18322 38.7513 6.91993 39.0317 6.91993 39.3757C6.91993 39.7196 7.18322 40 7.50612 40L32.7471 40C33.07 40 33.3333 39.7196 33.3333 39.3757L33.3333 20.0106L33.3333 20L33.3333 20.0053L33.3333 20L33.3333 0.62434C33.3333 0.280422 33.07 -2.30174e-08 32.7471 -5.12463e-08L7.50613 -2.25788e-06ZM33.3333 20C33.3134 18.7355 33.3333 19.7725 33.3333 20V20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.366 20.6243C21.6889 20.6243 21.9522 20.3439 21.9522 20C21.9522 19.6561 21.6889 19.3757 21.366 19.3757L0.586065 19.3756C0.263163 19.3756 -0.0001258 19.6561 -0.00012583 20C-0.00012586 20.3439 0.263163 20.6243 0.586065 20.6243L21.366 20.6243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0203 28.0053C12.7918 28.2487 12.7918 28.6455 13.0203 28.8889C13.2488 29.1323 13.6214 29.1323 13.8499 28.8889L21.7834 20.4445L21.3661 20L20.9488 20.4445C21.1773 20.6879 21.5499 20.6879 21.7784 20.4445C22.0069 20.2011 22.0069 19.8043 21.7784 19.5609C21.5499 19.3175 21.1773 19.3175 20.9488 19.5609L21.3661 20.0053L21.7834 19.5609L13.8499 11.1111C13.6214 10.8678 13.2488 10.8678 13.0203 11.1111C12.7918 11.3545 12.7918 11.7513 13.0203 11.9947L20.5365 20L13.0203 28.0053Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ";\n"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectButtonSvg);
export default __webpack_public_path__ + "static/media/disconnectButtonSvg.4b449e94c74f340aa15f95a115c054b4.svg";
export { ForwardRef as ReactComponent };